<template>
	<!--<v-btn dark @click="snackbar = true">Open Snackbar</v-btn>-->
	<v-snackbar v-model="$store.state.responseNotificationToggle" top
	            :color="$store.state.responseNotificationType"
	            :timeout="$store.state.responseNotificationTimeout"
	            class="response_notification">
		<v-row dense align="center">
			<v-col cols="1" align-self="center">
				<v-btn text icon id="notify_btn">
					<v-icon>notification_important</v-icon>
				</v-btn>
			</v-col>
			<v-col cols="10">
				<ul class="response_list">
					<li v-for="(data, index) in $store.state.responseNotificationMessages" :key="index">
						{{data}}
					</li>
				</ul>
			</v-col>
			<v-col cols="1" align-self="center">
				<v-btn text icon id="close_btn" @click="$store.commit('mutateResponseNotificationToggle', false)">
					<v-icon>close</v-icon>
				</v-btn>
			</v-col>
		</v-row>
	</v-snackbar>
</template>

<script>
    export default {
        data() {
            return {
                sample: [
                    "Τα στοιχεία που εισαγάγατε δεν είναι έγκυρα",
                    "Τα στοιχεία που εισαγάγατε δεν είναι έγκυρα",
                    "Τα στοιχεία που εισαγάγατε δεν είναι έγκυρα",
                ]
            }
        }
    }
</script>
